export default __webpack_public_path__ + "static/media/Harsh Kapse.ba6b0053.jpeg";